import * as React from "react";

import Field from "components/FormElements/Field";
import {
  FIELD_PROP_NAMES,
  FieldPropsType,
} from "components/FormElements/types";
import { take } from "utils";

const INPUT_PROP_NAMES = [
  "autoComplete",
  "defaultValue",
  "disabled",
  "id",
  "maxLength",
  "minLength",
  "name",
  "onBlur",
  "onChange",
  "placeholder",
  "required",
  "type",
  "value",
];

interface PropsType extends Omit<FieldPropsType, "children"> {
  autoComplete?: string;
  defaultValue?: string;
  disabled?: boolean;
  id?: string;
  maxLength?: number;
  minLength?: number;
  name: string;
  placeholder?: string;
  required?: boolean;
  type?: string;
  value?: string;
}

export default function TextField(props: PropsType): JSX.Element {
  const fieldProps = take(props, FIELD_PROP_NAMES);
  const inputProps = take(props, INPUT_PROP_NAMES);
  const { id, name, type = "text" } = inputProps;

  const identifer = id || name;

  return (
    <Field {...fieldProps}>
      <input {...inputProps} id={identifer} {...{ type }} />
    </Field>
  );
}
